import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

@Component({
    selector: 'syn-markdown',
    template: `
    <div
      class="syn-markdown-content"
      [innerHTML]="sanitizedHtml"
    ></div>
  `,
})
export class SynMarkdownComponent implements OnChanges, AfterViewInit {
    @Input() data?: string;

    sanitizedHtml = '';

    constructor(private host: ElementRef<HTMLElement>) {}

    ngOnChanges(changes: SimpleChanges): void {
        if ('data' in changes && this.data != null) {
            this.render(this.data);
        }
    }

    ngAfterViewInit(): void {
        if (this.data) {
            this.render(this.data);
        } else {
            this.handleTransclusion();
        }
    }

    private render(markdown: string): void {
        const rawHtml = marked.parse(markdown) as string;

        this.sanitizedHtml = DOMPurify.sanitize(rawHtml, {
            USE_PROFILES: { html: true },
            FORBID_TAGS: ['script', 'style', 'iframe'],
            FORBID_ATTR: ['style', 'on*'],
        });
    }

    private handleTransclusion(): void {
        const markdown = this.host.nativeElement.innerText.trim();
        if (markdown) {
            this.render(markdown);
        }
    }
}
